import React from 'react';
import { Link } from 'react-router-dom';
import Reveal from '../../../components/shared/Reveal';
import { EditableText, EditableImage, HrefPill } from '../../components';

function SecondaryFeature({ data, onChange }) {
  const update = (patch) => onChange && onChange({ ...data, ...patch });
  const paragraphs = data.paragraphs || [];
  const updatePara = (i, t) => {
    const next = [...paragraphs];
    next[i] = t;
    update({ paragraphs: next });
  };
  const updateCallout = (patch) => update({ callout: { ...(data.callout || {}), ...patch } });
  return (
    <section className="py-24 bg-olive-deep text-white">
      <div className="container-page grid lg:grid-cols-2 gap-16 items-center">
        <Reveal>
          <h2 className="font-display text-4xl sm:text-5xl leading-tight">
            <EditableText value={data.heading} onChange={(t) => update({ heading: t })} as="span" />
          </h2>
          {paragraphs.map((p, i) => (
            <EditableText
              key={i}
              value={p}
              onChange={(t) => updatePara(i, t)}
              as="p"
              multiline
              className={`${i === 0 ? 'mt-5' : 'mt-4'} text-white/80 leading-relaxed`}
            />
          ))}
          {data.callout && (
            <div className="mt-8 p-6 rounded-2xl bg-white/10 backdrop-blur border border-white/15">
              <EditableText value={data.callout.title} onChange={(t) => updateCallout({ title: t })} as="strong" className="text-accent" />
              <EditableText value={data.callout.body} onChange={(t) => updateCallout({ body: t })} as="p" multiline className="text-sm text-white/80 mt-2 leading-relaxed" />
              {data.callout.cta && (
                <div className="mt-4 inline-flex flex-col">
                  <Link to={data.callout.cta.href || '#'} className="btn-outline-light">
                    <EditableText
                      value={data.callout.cta.label}
                      onChange={(t) => updateCallout({ cta: { ...(data.callout.cta || {}), label: t } })}
                      as="span"
                    />
                  </Link>
                  <HrefPill value={data.callout.cta.href} onChange={(h) => updateCallout({ cta: { ...(data.callout.cta || {}), href: h } })} />
                </div>
              )}
            </div>
          )}
        </Reveal>
        <Reveal delay={0.1}>
          <EditableImage
            src={data.image?.src}
            alt={data.image?.alt || 'Secondary'}
            onChange={(src, alt) => update({ image: { src, alt } })}
            className="rounded-3xl shadow-2xl h-[520px] w-full object-cover"
          />
        </Reveal>
      </div>
    </section>
  );
}

export default SecondaryFeature;
